import { createContext } from "react";

export const GridSideContext = createContext(null);
export const GridContext = createContext(null);
export const GridSetContext = createContext(null);
export const EmptyIndsContext = createContext(null);
export const DecayNumsContext = createContext(null);